import { render, staticRenderFns } from "./AddQuote.vue?vue&type=template&id=1577884d&scoped=true"
import script from "./AddQuote.vue?vue&type=script&lang=js"
export * from "./AddQuote.vue?vue&type=script&lang=js"
import style0 from "./AddQuote.vue?vue&type=style&index=0&id=1577884d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577884d",
  null
  
)

export default component.exports